import { ContactFormSetting } from "@/server/backend-api/generated";
import { createBackendApiClient } from "./createBackendApiClient";

export async function getContactFormSettings(): Promise<ContactFormSetting[]> {
  const client = createBackendApiClient();
  return await client.support_GetAllContactFormSettings();
}
